/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */

import type { PenStyles } from './PenStyles.js';

/**
 * Pen state.
 *
 * @group CTA-608
 * @beta
 */
export class PenState {
	public foreground: string = 'white';
	public underline: boolean = false;
	public italics: boolean = false;
	public background: string = 'black';
	public flash: boolean = false;

	reset(): void {
		this.foreground = 'white';
		this.underline = false;
		this.italics = false;
		this.background = 'black';
		this.flash = false;
	}

	setStyles(styles: Partial<PenStyles>): void {
		const attribs = [
			'foreground',
			'underline',
			'italics',
			'background',
			'flash',
		];
		for (let i = 0; i < attribs.length; i++) {
			const style = attribs[i];
			if (Object.prototype.hasOwnProperty.call(styles, style)) {
				(this as any)[style] = (styles as any)[style];
			}
		}
	}

	isDefault(): boolean {
		return (
			this.foreground === 'white' &&
			!this.underline &&
			!this.italics &&
			this.background === 'black' &&
			!this.flash
		);
	}

	equals(other: PenState): boolean {
		return (
			this.foreground === other.foreground &&
			this.underline === other.underline &&
			this.italics === other.italics &&
			this.background === other.background &&
			this.flash === other.flash
		);
	}

	copy(newPenState: PenState): void {
		this.foreground = newPenState.foreground;
		this.underline = newPenState.underline;
		this.italics = newPenState.italics;
		this.background = newPenState.background;
		this.flash = newPenState.flash;
	}
}
